import { siteConfig } from "../data/mock";

export const Footer = () => {
  const links = [
    { label: "IMDb", url: siteConfig.imdb },
    { label: "Vimeo", url: siteConfig.vimeo },
    { label: "YouTube", url: siteConfig.youtube },
    { label: "Letterboxd", url: siteConfig.letterboxd },
  ];

  return (
    <footer className="border-t border-[#e8e6e3] bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="font-serif text-[15px] text-[#1a1a1a] tracking-[0.02em]">
            {siteConfig.director}
          </p>

          <div className="flex items-center gap-8">
            {links.map((link) => (
              <a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[12px] text-[#666] tracking-[0.08em] uppercase hover:text-[#1a1a1a] transition-colors duration-500"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[#f0eeeb]">
          <p className="text-[11px] text-[#bbb] tracking-[0.06em]">
            © {new Date().getFullYear()} {siteConfig.director}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
